import { useDispatch, useStore } from "react-redux";
import { CardBox, PartnerContainer } from "../../style/partnerStylemain"
import PartnerHeader from "./PartnerHeader"
import { getMaskedMobileNoForOtp, getSummaryStructure, requestOTP } from "../../store/publicPartner/action"
import { useEffect, useRef, useState } from "react";
import { PartnerKnowledgeSummaryStructure } from "../../model/request/partner-knowledge";
import { NOT_FOUND_LABEL } from "../../api/label";
import { queryclear } from "../../store/search/actions";
import { useHistory, useParams } from "react-router-dom";
import { AlertContainer } from "react-custom-alert";
import { alert } from "react-custom-alert";
import PartnerOtpVerification from "./shared/PartnerOtpVerification";

const ALERT_FLOATING_TIME = 3000;

type Props = {}

type OtpSearchHandlers = {
    setRefCode: (value?: string) => void;
    setMaskedMobileNo: (value?: string) => void;
    setRequestMaskedMobileNo: (value?: string) => void;
    setTimeLeftSecond: (value?: number) => void;
    pushSummaryLink: (link: string) => void;
    onOtpRequested: () => void;
    onVerified: () => void;
}

const applyOtpSearchData = (res: any, handlers: OtpSearchHandlers) => {
    if (res.data == null) {
        alert({ message: NOT_FOUND_LABEL, type: 'error' });
        return;
    }
    if (res.table === 'partner-otp') {
        handlers.onOtpRequested();
        handlers.setRefCode(res.data.refCode);
        handlers.setMaskedMobileNo(res.data.maskedMobileNo);
        handlers.setTimeLeftSecond(res.data.timeLeftSecond);
    } else if (res.table === 'partner-otp-masked-mobile-no') {
        handlers.setRequestMaskedMobileNo(res.data.maskedMobileNo);
    } else if (res.table === 'summary-structure') {
        handlers.onVerified();
        sessionStorage.setItem("publicAccessCode", JSON.stringify(res.data.publicAccessCode))
        sessionStorage.setItem("summaryState", "COMPLETED");
        handlers.pushSummaryLink(res.data.link);
    }
}

const PartnerOtp = (props: Props) => {

    const dispatch = useDispatch();
    const [refCode, setRefCode] = useState<string | undefined>();
    const [maskedMobileNo, setMaskedMobileNo] = useState<string | undefined>();
    const [requestMaskedMobileNo, setRequestMaskedMobileNo] = useState<string | undefined>();
    const [mobileNo, setMobileNo] = useState<string>();
    const [timeLeftSecond, setTimeLeftSecond] = useState<number | undefined>();
    const [loading, setLoading] = useState(false);
    const store = useStore();
    const history = useHistory()
    let { userKey } = useParams<{ userKey: string }>();
    const isVerifyingRef = useRef(false);
    const isRequestingOtpRef = useRef(false);

    useEffect(() => {
        const unsubscribe = store.subscribe(() => {
            var res = store.getState().SearchReducer;
            if (res.isLoading) {
                setLoading(true);
            } else if (res.isLoaded) {
                setLoading(false);
                applyOtpSearchData(res, {
                    setRefCode,
                    setMaskedMobileNo,
                    setRequestMaskedMobileNo,
                    setTimeLeftSecond,
                    pushSummaryLink: (link) => history.push(link),
                    onOtpRequested: () => { isRequestingOtpRef.current = false; },
                    onVerified: () => { isVerifyingRef.current = false; },
                });
            } else if (res.isNotFound) {
                alert({ message: NOT_FOUND_LABEL, type: 'error' });
                setLoading(false);
            } else if (res.isUpdated) {
                dispatch(queryclear);
            } else if (res.isFailed) {
                isVerifyingRef.current = false;
                isRequestingOtpRef.current = false;
                setLoading(false);
                alert({ message: res.data.message, type: 'error' });
            }
        });
        dispatch(getMaskedMobileNoForOtp(userKey));
        return unsubscribe;
    }, []);

    const handleRequestOtp = (captchaToken: string) => {
        if (isRequestingOtpRef.current) return;
        isRequestingOtpRef.current = true;
        const body: PartnerKnowledgeSummaryStructure = {
            userKey: userKey,
            mobileNo: mobileNo,
            captchaToken: captchaToken
        }
        dispatch(requestOTP(userKey, body));
    }

    const handleVerify = (otp: string) => {
        if (isVerifyingRef.current) return;
        isVerifyingRef.current = true;
        const body: PartnerKnowledgeSummaryStructure = {
            userKey: userKey,
            mobileNo: mobileNo,
            refCode: refCode,
            otp: otp
        }
        dispatch(getSummaryStructure(body));
    }

    return (
        <div className='bg-light-gray partner-page' style={{ height: "100vh", fontFamily: "DB Helvethaica" }}>
            <div style={{ position: 'sticky', top: 0 }}>
            </div>
            <div className="student-wrapper-header-inner" style={{ background: "#38383D" }}>
                <PartnerHeader />
            </div>
            <PartnerContainer className='mt-3' style={{ maxWidth: 550 }}>
                <CardBox>
                    <PartnerOtpVerification
                        refCode={refCode}
                        maskedMobileNo={maskedMobileNo}
                        requestMaskedMobileNo={requestMaskedMobileNo}
                        timeLeftSecond={timeLeftSecond}
                        loading={loading}
                        onRequestOtp={handleRequestOtp}
                        onVerifyOtp={handleVerify}
                        requestDescription={<>ระบบจะส่งรหัส OTP ไปยังเบอร์มือถือที่ท่านลงทะเบียนไว้ เพื่อใช้ในการเปิดดูข้อมูลการแนะนำหลักสูตรและสื่อความรู้ที่ท่านสนใจ</>}
                        verifyLabel="ยืนยัน"
                        verifyDescription={<>กรุณากรอกรหัสยืนยันที่ได้รับผ่านทาง SMS<br />เพื่อใช้ในการเปิดดูข้อมูลการแนะนำหลักสูตรและสื่อความรู้ที่ท่านสนใจ</>}
                    />
                </CardBox>
                <AlertContainer floatingTime={ALERT_FLOATING_TIME} />
            </PartnerContainer>
        </div>
    )
}

export default PartnerOtp
